export default __webpack_public_path__ + "static/media/informeventas.807df2b8.png";